import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import ReactTable from 'react-table';
import moment from 'moment';

class TableHistory extends Component {

    constructor(props) {
        super(props);

        // this.refreshTable = this.refreshTable.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            historicoPedido: this.props.historicoPedido,
            pages: this.props.pages,
            loading: this.props.loading,
            rowSelected: -1
        }

        this.columns = [
            {
                Header: 'Ação',
                accessor: 'acao',
                className: 'text-left',
                width: 190
            },
            {
                Header: 'Dt. Modificação',
                accessor: 'dtModificacao',
                className: 'text-center',
                Cell: row => (<span>{moment(row.value).format('DD/MM/YYYY')}</span>),
                width: 100
            },
            {
                Header: 'Usuário',
                accessor: 'usuarioModificador',
                className: 'text-center',
                width: 80
            },
            {
                Header: 'Valor Antigo',
                accessor: 'valorAntigo',
                className: 'text-center',
                // width: ''
            },
            {
                Header: 'Novo Valor',
                accessor: 'valorAtual',
                className: 'text-center',
                // width: ''
            },

        ]

    }

    render() {
        return (
            <div className="row table-clients">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <ReactTable
                                data={this.props.historicoPedido}
                                columns={this.columns}
                                onFetchData={this.refreshTable}
                                defaultPageSize={5}
                                pages={this.state.pages}
                                manual
                                loading={this.state.loading}
                                className="-striped -highlight"
                                headerClassName="ebs-table-header"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhum histórico de ação.'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                            />

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TableHistory;